import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Localization from "../../../localization";
import Button from "../../../components/button";
import CalendarComponent from "../../../components/calendar";
import { DateTime } from "luxon";

class Calendar extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { locale } = this.props;

        return (
            <div className="px-16 xl:px-50 pt-60 xl:pt-80 pb-60 bg-grey">
                <h1 className="font-judge font-bold uppercase text-center text-50 xl:text-100 text-blue mb-24 xl:mb-80">
                    {Localization[locale].home.calendar}
                </h1>
                <CalendarComponent />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
